import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { unitPrice } from '../../../../../../../utils/product'
import { useSelector } from 'react-redux'

export default props => {
    useStyles(classes)
    const { couponAlert, onClick, couponMsg } = props
    const ui = useSelector(state => state.ui)

    const closed = ui.direction === 'up'
    return <div className={`${classes.CouponAlert} ${closed? classes.Closed: ''}`} onClick={onClick}>
        {
            couponAlert?.hasLargerCoupon?<div className={classes.Icon}>
                <img src="https://image.geeko.ltd/chicme/20250410/coupon3_2.png" />
            </div>:<div className={classes.Icon}><img src="https://image.geeko.ltd/chicme/20250410/coupon3.png" /></div>
        }
        <div className={classes.Bd}>
            {
                couponAlert?.msg ? <React.Fragment>
                    <div>
                        <div className={classes.Amount}>{unitPrice(couponAlert.saveAmount)}</div>
                        <div className={classes.Msg}>{couponAlert.msg}</div>
                    </div>
                </React.Fragment> : <React.Fragment>
                    <div className={classes.couponMsg}><span>{couponMsg?.msg}</span></div>
                </React.Fragment>
            }
        </div>
    </div>
}